module.exports = __webpack_public_path__ + "img/poster_animation_logo_blanc.a69c7fb2.jpg";